import React, { useMemo } from 'react';
import styled, { keyframes } from 'styled-components';
import { useAuth } from '../context/AuthContext';
import { useTranslation } from 'react-i18next';
import { COLORS } from '../constants/colors';

/* ───── Animations ───── */
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const shimmer = keyframes`
  0%   { background-position: -200% center; }
  100% { background-position: 200% center; }
`;

/* ───── Styled Components ───── */
const GreetingWrapper = styled.div`
  animation: ${fadeIn} 0.5s ease-out;
`;

const GreetingText = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 6px 0;
  line-height: 1.3;
  color: #1a1a2e;
  letter-spacing: -0.02em;
`;

const UserName = styled.span`
  background: linear-gradient(
    90deg,
    ${COLORS.PRIMARY} 0%,
    ${COLORS.PRIMARY_LIGHT || '#7c6dd8'} 50%,
    ${COLORS.PRIMARY} 100%
  );
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: ${shimmer} 4s linear infinite;
`;

/* ───── Greeting keys (22 variants) ───── */
const GREETING_COUNT = 22;

function getFirstName(displayName: string | undefined): string {
  if (!displayName) return '';
  return displayName.split(' ')[0];
}

/* ───── Component ───── */
export const PersonalizedGreeting: React.FC = () => {
  const { user, isLoggedIn } = useAuth();
  const { t } = useTranslation();
  const firstName = getFirstName(user?.username || user?.email);

  const greetingIndex = useMemo(
    () => Math.floor(Math.random() * GREETING_COUNT),
    []
  );

  if (!isLoggedIn || !firstName) return null;

  const before = t(`greeting.g${greetingIndex}.before`, { name: firstName });
  const after = t(`greeting.g${greetingIndex}.after`, { name: firstName });

  return (
    <GreetingWrapper>
      <GreetingText>
        {before}<UserName>{firstName}</UserName>{after}
      </GreetingText>
    </GreetingWrapper>
  );
};